import React from "react";
import { toggle } from "../../../../util/common";
import CreditRatingScoreAndLimit from "./CreditRatingScoreAndLimit";
import CreditRatingImpact from "./CreditRatingImpact";
import { IBusinessCreditReportResponse, BusinessCreditReportStatePII } from "../../../../store/businessCreditReportService/types";

interface IProps {
    bCreditReportData: IBusinessCreditReportResponse;
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
    creditProvider?: any;
}
const CreditRating: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div className="drawer-container">
                <div className="drawer-header">
                    {props.showAsAccordion ? (
                        <button
                            aria-expanded="false"
                            className="btn-default btn-toggle btn-drawer"
                            id="btn-credit-rating"
                            onClick={() => toggle("credit-rating", "btn-credit-rating")}
                        >
                            <span className="btn-toggle-status sr-only">Show</span>
                            <span className="btn-text">Credit Rating</span>
                        </button>
                    ) : (
                        <h3>Credit Rating</h3>
                    )}
                </div>

                <div className="drawer-content" id="credit-rating" style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}>
                    <div role="list" className="data-grid has-lines margin-top-s" id="">
                        <CreditRatingScoreAndLimit
                            bCreditReportData={props.bCreditReportData}
                            reportObject={props.reportObject}
                            showAsAccordion={props.showAsAccordion}
                        />
                        <CreditRatingImpact showAsAccordion={props.showAsAccordion} creditProvider={props.creditProvider} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CreditRating;
